import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _isNil from 'lodash/isNil';
import DimensionUtils from './dimensions';
import { extractTransformProperties } from '../../../utils/dom';
export var PopupUtils = /*#__PURE__*/function () {
  function PopupUtils() {
    _classCallCheck(this, PopupUtils);
  }
  _createClass(PopupUtils, null, [{
    key: "getSafePosition",
    value: function getSafePosition(triggerRef) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$position = _ref.position,
        position = _ref$position === void 0 ? 'bottom center' : _ref$position,
        _ref$leftPosition = _ref.leftPosition,
        leftPosition = _ref$leftPosition === void 0 ? 'bottom left' : _ref$leftPosition,
        _ref$rightPosition = _ref.rightPosition,
        rightPosition = _ref$rightPosition === void 0 ? 'bottom right' : _ref$rightPosition;
      if (!triggerRef) {
        return position;
      }
      var _DimensionUtils$getRe = DimensionUtils.getRelativeDistanceToWindowBorders(triggerRef),
        tooCloseToLeft = _DimensionUtils$getRe.tooCloseToLeft,
        tooCloseToRight = _DimensionUtils$getRe.tooCloseToRight;
      if (tooCloseToLeft) {
        return leftPosition;
      }
      if (tooCloseToRight) {
        return rightPosition;
      }
      return position;
    }
  }, {
    key: "makePopupFullWidth",
    value: function makePopupFullWidth(popupElement) {
      if (typeof window === 'undefined' || !popupElement) {
        return;
      }
      var component = popupElement;
      var _extractTransformProp = extractTransformProperties(popupElement.parentNode),
        translateX = _extractTransformProp.translateX;
      if (!_isNil(translateX)) {
        component.style.transform = "translateX(".concat(-translateX, "px)");
        component.style.width = '100vw';
        component.style.minWidth = '100vw';
        component.style.maxWidth = '100vw';
        component.style.setProperty('display', 'none', 'before');
      }
    }
  }]);
  return PopupUtils;
}();